import { render, staticRenderFns } from "./info.modal.vue?vue&type=template&id=057d64d0&scoped=true"
import script from "./info.modal.vue?vue&type=script&lang=js"
export * from "./info.modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057d64d0",
  null
  
)

export default component.exports